module.exports = require("babel-core");


//////////////////
// WEBPACK FOOTER
// external "babel-core"
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7 8 9 15